import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Drawer } from '@material-ui/core';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import BarChartIcon from '@material-ui/icons/BarChart';
import BusinessIcon from '@material-ui/icons/Business';
import GroupIcon from '@material-ui/icons/Group';
import WebIcon from '@material-ui/icons/Web';
import MemoryIcon from '@material-ui/icons/Memory'
import routes from 'routes';

import { SidebarNav } from './components';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props;

  const classes = useStyles();

  const pages = [
    {
      title: routes.reports.menuTitle,
      href: routes.reports.path,
      icon: <BarChartIcon />
    },
    {
      title: routes.agencies.menuTitle,
      href: routes.agencies.path,
      icon: <BusinessIcon />
    },
    {
      title: routes.users.menuTitle,
      href: routes.users.path,
      icon: <GroupIcon />
    },
    {
      title: routes.brands.menuTitle,
      href: routes.brands.path,
      icon: <ShoppingBasketIcon />
    },
    {
      title: routes.compliances.menuTitle,
      href: routes.compliances.path,
      icon: <WebIcon />
    },
    {
      title: routes.summary.menuTitle,
      href: routes.summary.path,
      icon: <WebIcon />
    },
    {
      title: routes.userAgent.menuTitle,
      href: routes.userAgent.path,
      icon: <MemoryIcon />
    },
  ];

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <SidebarNav
          className={classes.nav}
          pages={pages}
        />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
